import { EmployeeProfileSelectComponent } from './form/employee-select.component';
import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { FormlyModule, FormlyFieldConfig } from "@ngx-formly/core";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FileTypeComponent } from "./form/file-type.component";
import { FileValueAccessor } from "./form/File-value-accessor";
import { CandidateGridComponent } from './candidate-grid/candidate-grid.component';
import { CandidateStatusComponent } from './candidate-status/candidate-status.component';
import { EmailComponent } from './email/email.component';
import {
  EmailValidatorMessage, EmailValidator, IntegerValidator,
  IntegerValidatorMessage, IntegerwithNAValidatorMessage, IntegerwithNAValidator, customError, blankSpaceValidator
} from './form/form-validators';
import { DatepickerTypeComponent } from './form/datepicker-type.component';
import { NgbPopoverModule, NgbTooltipModule, NgbToastModule, NgbModule, NgbAccordionModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ImmigrationFileUploadComponent } from './file-upload/immigration-file-upload.component';
import { LoaderComponent } from './loader/loader.component';
import { AlertComponent } from './alert/alert.component';
import { FileSizeLimitDirective } from '../core/directives/file-size-limit.directive';

import { CommentComponent } from './comment/comment.component';
import { HasAccessDirective } from '../core/directives/has-access.directive';
import { ArCommentComponent } from './ar-comment/ar-comment.component';
import { ToastComponent } from './toast/toast.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { LocalDatePipe } from '../core/pipes/local-date.pipe';

import { DebounceClickDirective } from '../core/directives/debounce-click.directive';
import { ReplacePipe } from '../core/pipes/replace.pipe';


import { NgSelectModule } from '@ng-select/ng-select';
// import { XsrfDirective } from '../core/directives/xsrf.directive';

import { CookieService } from 'ngx-cookie-service';
import { CandidateProfileComponent } from './candidate-profile/candidate-profile.component';
import { TimeoutWindowComponent } from './timeout-window/timeout-window.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PhoneNumberPickerComponent } from './form/phone-number-picker/phone-number-picker.component';
import { HistoryComponent } from './history/history.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { ImmigrationGridComponent } from './immigration-grid/immigration-grid.component';
import { StringLimitPipe } from '../core/pipes/string-limit.pipe';
import { TypeaheadTypeComponent } from './form/type-ahead/typeahead-type.component';
import { ClipboarderDirective } from '../core/directives/clipboarder.directive';
import { PhoneFieldComponent } from './form/phone-field/phone-field.component';
import { DateTime } from './form/date-time.component';
import { CopyableFieldWrapperComponent } from './form/copyable-field-wrapper.component';
import { CopyableInputComponent } from './form/copyable-input/copyable-input.component';
import { ImmigrationCommentsComponent } from './immigration-comments/immigration-comments.component';
import { ButtonFieldWrapperComponent } from './form/button-field-wrapper/button-field-wrapper.component';
import { FilterComponent } from './filter/filter.component';
import { DateRangeFilterComponent } from './date-range-filter/date-range-filter.component';
import { PascalToSentencePipe } from '../core/pipes/pascal-to-sentence.pipe';
import { RouterModule } from '@angular/router';
import { TemplateSelectComponent } from './form/template-select.component';
import { CustomSelectComponent } from './form/custom-select.component';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { ImmigrationEmailComponent } from './immigration-email/immigration-email.component';
import { GovernanceEmailComponent } from './governance-email/governance-email.component';
import { ImmigrationTitlePipe } from '../core/pipes/immigration-title.pipe';
import { ArrayListInputComponent, ArrayPickerComponent, RepeatTypeComponent, RepeatRangeTypeComponent } from './form/array-picker/array-picker.component';
import { UserEditorComponent } from './user-editor/user-editor.component';
import { TooltipWrapperComponent } from './form/tooltip-wrapper/tooltip-wrapper.component';
import { TypeAheadSelectComponent } from './form/type-ahead-select/type-ahead-select.component';
import { EmployeeProfileCommentsComponent } from './immigration-comments/employee-profile-comments.component';
import { ConfigurableMailComponent } from './configurable-mail/configurable-mail.component';
import { FormlyButtonComponent } from './form/formly-button/formly-button.component';
import { InvalidityShowWrapperComponent } from './form/invalidity-show-wrapper.component';
import { TypeAheadSelectEmployeeComponent } from './form/type-ahead-select employee/type-ahead-select-employee.component';
import { MilestoneBasicComponent } from './milestone-basic/milestone-basic.component';
import { DocumentNamePipe } from "../core/pipes/document-name.pipe";
import { ConfigurableTypeAheadComponent } from './form/configurable-type-ahead/configurable-type-ahead.component';
import { ExitFileUploadComponent } from "./file-upload/exit-file-upload.component";
import { ConfigurableCommentComponent } from './configurable-comment/configurable-comment.component';
import { AdditionalDetailPickerComponent } from './form/additional-detail-picker/additional-detail-picker.component';
import { InfoTemplateComponent } from "../exit/components/exit-additional-info/info-template/info-template.component";
import { ViewTeamInfo } from "../exit/directives/view-team-info.directive";
import { CurrencyFieldComponent } from './form/currency-field/currency-field.component';
import { FormlyFieldButtonComponent } from './form/formly-button/formly-field-button.component';
import { TypeAheadAirportsComponent } from './form/type-ahead-airports/type-ahead-airports.component';
import { AdditionalDocRequestComponent } from './additional-doc-request/additional-doc-request.component';

import { TemplateSelectExitComponent } from './form/template-select-exit.component';

import { ImmigrationRequestcopydialogComponent } from './immigration-requestcopydialog/immigration-requestcopydialog.component';
import { ShareDocumentsComponent } from './share-documents/share-documents.component';
import { NotificationGridComponent } from './notification-grid/notification-grid.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TypeAheadLocationsComponent } from './form/type-ahead-locations/type-ahead-locations.component';
import { CandidateAdditionDocRequestComponent } from './candidate-addition-doc-request/candidate-addition-doc-request.component';
import { CommentConfirmationComponent } from './comment-confirmation/comment-confirmation.component';
import { MilestoneComponent } from './milestone/milestone.component';
import { GovernanceMilestoneComponent } from './governance-milestone/governance-milestone.component';
import { ExitBulkUploadComponent } from './exit-bulk-upload/exit-bulk-upload.component';
import { MultiSelectComponent } from './form/multi-select/multi-select.component';
import { WorkingDayPipe } from '../core/pipes/working-day.pipe';
import { BulkUploadConfirmationComponent } from './bulk-upload-confirmation/bulk-upload-confirmation.component';
import { EmpAdditionalDocRequestComponent } from './emp-additional-doc-request/emp-additional-doc-request.component';
import { TypeaheadTypeComponentWithDisplayText } from './form/type-ahead/typeahead-type.component-with-displayText';
import { AdditionalTeamDetailPickerComponent } from './form/additional-team-detail-picker/additional-team-detail-picker.component';
import { CWFileUploadComponent } from './file-upload/cwfile-upload.component';
import { CandidatePendingDocRequestComponent } from './candidate-pending-doc-request/candidate-pending-doc-request.component';
import { TimelineReportComponent } from './timeline-report/timeline-report.component';
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { ListFilterPipe } from './multi-select-dropdown/list-filter.pipe';
import { ClickOutsideDirective } from './multi-select-dropdown/click-outside.directive';
import { PendingactionReportComponent } from './pendingaction-report/pendingaction-report.component';

import { SearchableSelectComponent } from './form/type-ahead/Searchable-select.component';
import { RecruitmentHistoryComponent } from  './history/RecruitmentHistory.Component';


export interface StepType {
  label: string;
  fields: FormlyFieldConfig[];
}

@NgModule({
  declarations: [
    ClickOutsideDirective,
    ListFilterPipe,
    CandidateProfileComponent,
    FileValueAccessor,
    FileTypeComponent,
    DatepickerTypeComponent,
    TemplateSelectComponent,
    CustomSelectComponent,
    PhoneNumberPickerComponent,
    CandidateGridComponent,
    CandidateStatusComponent,
    EmailComponent,
    FileUploadComponent,
    ImmigrationFileUploadComponent,
    LoaderComponent,
    AlertComponent,
    FileSizeLimitDirective,
    DebounceClickDirective,
    CommentComponent,
    HasAccessDirective,
    CWFileUploadComponent,
    // XsrfDirective,
    ArCommentComponent,
    ToastComponent,
    LocalDatePipe,
    DocumentNamePipe,
    ReplacePipe,
    TypeaheadTypeComponent,
    TypeaheadTypeComponentWithDisplayText,
    TimeoutWindowComponent,
    HistoryComponent,
    PdfViewerComponent,
    ImageViewerComponent,
    ImmigrationGridComponent,
    StringLimitPipe,
    PascalToSentencePipe,
    ClipboarderDirective,
    PhoneFieldComponent,
    DateTime,
    CopyableFieldWrapperComponent,
    CopyableInputComponent,
    ImmigrationCommentsComponent,
    EmployeeProfileCommentsComponent,
    ButtonFieldWrapperComponent,
    FilterComponent,
    DateRangeFilterComponent,
    ImmigrationEmailComponent,
    GovernanceEmailComponent,
    ImmigrationTitlePipe,
    ArrayPickerComponent,
    ArrayListInputComponent,
    RepeatTypeComponent,RepeatRangeTypeComponent,
    UserEditorComponent,
    TooltipWrapperComponent,
    TypeAheadSelectComponent,
    TypeAheadSelectEmployeeComponent,
    ConfigurableMailComponent,
    FormlyButtonComponent,
    InvalidityShowWrapperComponent,
    MilestoneBasicComponent,
    ConfigurableTypeAheadComponent,
    ExitFileUploadComponent,
    ConfigurableCommentComponent,
    AdditionalDetailPickerComponent,
    InfoTemplateComponent,
    ViewTeamInfo,
    EmployeeProfileSelectComponent,
    CurrencyFieldComponent,
    FormlyFieldButtonComponent,
    TypeAheadAirportsComponent,

    AdditionalDocRequestComponent,
    TemplateSelectExitComponent,


    ShareDocumentsComponent,
    ImmigrationRequestcopydialogComponent,
     NotificationGridComponent,
    TypeAheadLocationsComponent ,
    CandidateAdditionDocRequestComponent,
    CommentConfirmationComponent,
    ExitBulkUploadComponent,
    MilestoneComponent,
    GovernanceMilestoneComponent,
    MultiSelectComponent,
    WorkingDayPipe,
    BulkUploadConfirmationComponent,
    EmpAdditionalDocRequestComponent,
    CandidatePendingDocRequestComponent,
    TimelineReportComponent,
    MultiSelectDropdownComponent,
    PendingactionReportComponent ,
    SearchableSelectComponent,
    RecruitmentHistoryComponent
     
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgbPopoverModule,
    NgbTooltipModule,
    NgbToastModule,
    NgSelectModule,
    FormlySelectModule,
    BsDatepickerModule.forRoot(),
    FormlyModule.forRoot({
      wrappers: [
        { name: "copyable-field", component: CopyableFieldWrapperComponent },
        { name: "button-field", component: ButtonFieldWrapperComponent },
        { name: "tooltip-field", component: TooltipWrapperComponent },
        { name: 'eos-button-field-wrapper', component: ButtonFieldWrapperComponent },
        { name: 'no-harm-error', component: InvalidityShowWrapperComponent }
      ],
      types: [
        { name: "file", component: FileTypeComponent, wrappers: ["form-field"] },
        { name: "datepicker", component: DatepickerTypeComponent, wrappers: ["form-field"] },
        { name: "template-select", component: TemplateSelectComponent, wrappers: ["form-field"] },
        { name: "employee-select", component: EmployeeProfileSelectComponent, wrappers: ["form-field"] },
        { name: "eos-select", component: CustomSelectComponent, wrappers: ["form-field"] },
        { name: "ad-typeahead", component: TypeaheadTypeComponent, wrappers: ["copyable-field"] },
        { name: "ad-typeahead-with-displayText", component: TypeaheadTypeComponentWithDisplayText, wrappers: ["copyable-field"] },
        { name: "typeahead-select", component: TypeAheadSelectComponent, wrappers: ["copyable-field"] },
        { name: "typeahead-select-employee", component: TypeAheadSelectEmployeeComponent, wrappers: ["copyable-field"] },
        { name: "typeahead-select-airport", component: TypeAheadAirportsComponent, wrappers: ["copyable-field"] },
        { name: "template-select-exit", component: TemplateSelectExitComponent, wrappers: ["form-field"] },
        { name: "typeahead-select-locations", component: TypeAheadLocationsComponent, wrappers: ["form-field"] },
        { name: "multi-select", component: MultiSelectComponent, wrappers: ["form-field"] },

        { name: "phone-number", component: PhoneNumberPickerComponent, wrappers: ["form-field"] },
        {
          name: "phone-field",
          component: PhoneFieldComponent,
          wrappers: ["form-field"],
          defaultOptions: {
            fieldGroup: [
              { type: 'input', key: 'countryCode' },
              {
                type: 'input',
                key: 'phoneNumber', templateOptions: { type: "text" }
              },
              // Prototypes follows - plugin or add the variable names down here for your purpose
              {
                type: 'input',
                key: 'emergencyContact', templateOptions: { type: "text" }
              },
              {
                type: 'input',
                key: 'emergencyContactCode', templateOptions: { type: "text" }
              }
            ]
          }
        },
        {
          name: "currency-field",
          component: CurrencyFieldComponent,
          wrappers: ["form-field"],
          defaultOptions: {
            fieldGroup: [
              { type: 'input', key: 'currencyCode' },
              {
                type: 'input',
                key: 'amount', templateOptions: { type: "text" }
              },
              // 
              { type: 'input', key: 'exGratiaCurrency' },
              {
                type: 'input',
                key: 'exGratiaAmount', templateOptions: { type: "number" }
              },
              // 
              { type: 'input', key: 'paymentInLieuCurrency' },
              {
                type: 'input',
                key: 'paymentInLieuAmount', templateOptions: { type: "number" }
              }
            ]
          }
        },
        { name: "date-time", component: DateTime, wrappers: ["form-field"] },
        { name: "array-picker", component: ArrayPickerComponent, wrappers: ["form-field"] },
        { name: "additional-info-picker", component: AdditionalDetailPickerComponent, wrappers: ["form-field"] },
        { name: 'repeat', component: RepeatTypeComponent },
        { name: 'repeat-range', component: RepeatRangeTypeComponent },
        { name: 'team-lead-info', component: AdditionalTeamDetailPickerComponent },
        { name: "just-a-button", component: FormlyButtonComponent },
        { name: "config-type-ahead", component: ConfigurableTypeAheadComponent, wrappers: ["form-field"] },
        { name: "eos-button", component: FormlyFieldButtonComponent },
         {
  name: 'grade-select',
  component: SearchableSelectComponent,
  wrappers: ['form-field']
},

      ],
      validators: [
        { name: 'email', validation: EmailValidator },
        { name: 'integer', validation: IntegerValidator },
        { name: 'integerwithNA', validation: IntegerwithNAValidator },
        { name: 'blankSpace', validation: blankSpaceValidator }
      ],
      validationMessages: [
        { name: 'required', message: 'This field is required' },
        { name: 'blankSpace', message: 'This field is required' },
        { name: 'email', message: EmailValidatorMessage },
        { name: 'integer', message: IntegerValidatorMessage },
        { name: 'integerwithNA', message: IntegerwithNAValidatorMessage },
        { name: 'custom-error', message: customError },
      ]
    }),
    FormlyBootstrapModule,
    FormsModule,
    EditorModule,
    NgMultiSelectDropDownModule,
    NgxExtendedPdfViewerModule,
    NgbAccordionModule,
    NgbCollapseModule,
    PaginationModule.forRoot()
  ],
  exports: [
    CommonModule,
    CandidateProfileComponent,
    ReactiveFormsModule,
    FormlyModule,
    FormlyBootstrapModule,
    CandidateGridComponent,
    CandidateStatusComponent,
    FileUploadComponent,
    ImmigrationFileUploadComponent,
    CWFileUploadComponent,
    LoaderComponent,
    AlertComponent,
    FileSizeLimitDirective,
    DebounceClickDirective,
    CommentComponent,
    ImmigrationCommentsComponent,
    EmployeeProfileCommentsComponent,
    HasAccessDirective,
    // XsrfDirective,
    ClipboarderDirective,
    CopyableInputComponent,
    ArCommentComponent,
    ToastComponent,
    LocalDatePipe,
    DocumentNamePipe,
    NgbTooltipModule,
    ReplacePipe,
    FormsModule,
    PdfViewerComponent,
    ImageViewerComponent,
    NgSelectModule,
    ImmigrationGridComponent,
    StringLimitPipe,
    DateRangeFilterComponent,
    PascalToSentencePipe,
    ImmigrationTitlePipe,
    ArrayListInputComponent,
    UserEditorComponent,
    ConfigurableMailComponent,
    MilestoneBasicComponent,
    FilterComponent,
    ExitFileUploadComponent,
    ConfigurableCommentComponent,
    InfoTemplateComponent,
    ViewTeamInfo,
    AdditionalDocRequestComponent,
    ImmigrationRequestcopydialogComponent,
    CandidateAdditionDocRequestComponent,
    CommentConfirmationComponent,
    ExitBulkUploadComponent,
    MilestoneBasicComponent,
    WorkingDayPipe, BulkUploadConfirmationComponent, EmpAdditionalDocRequestComponent

  ],
  providers: [CookieService, DatePipe,ListFilterPipe],
//   entryComponents: [
//     ImageViewerComponent,
//     PdfViewerComponent,
//     HistoryComponent,
//     AlertComponent,
//     CommentComponent,
//     ArCommentComponent,
//     TimeoutWindowComponent,
//     ImmigrationCommentsComponent,
//     DateRangeFilterComponent,
//     EmailComponent,
//     ImmigrationEmailComponent,
//     ArrayListInputComponent,
//     UserEditorComponent,
//     EmployeeProfileCommentsComponent,
//     ConfigurableMailComponent,
//     MilestoneBasicComponent,
//     ConfigurableMailComponent,
//     ConfigurableCommentComponent,
//     InfoTemplateComponent,
//     AdditionalDocRequestComponent,
//     ImmigrationRequestcopydialogComponent,
//     NotificationGridComponent,
//     CandidateAdditionDocRequestComponent,
//     CommentConfirmationComponent,
//     MilestoneComponent,
//     ExitBulkUploadComponent, BulkUploadConfirmationComponent, EmpAdditionalDocRequestComponent
//   ]

})
export class SharedModule { }
